export default (el) => el.value;
